import type { BackendClient } from '@healthshare/shared/platform/backendClient'
import { joinBackendUrl } from '@healthshare/shared/platform/backendClient'

/**
 * The web app's BackendClient.
 *
 * The base URL is empty, so requests stay origin-relative exactly as they were
 * before this seam existed -- Kong fronts both the web app and the Laravel admin
 * app on one origin, which is what makes `/backend/...` resolve. React Native has
 * no document origin and supplies a real base URL instead.
 */
export function createWebBackendClient(baseUrl = ''): BackendClient {
  return {
    fetch(path, init) {
      return fetch(joinBackendUrl(baseUrl, path), init)
    },
  }
}

export const webBackendClient = createWebBackendClient()
